import {
  ADD_PRODUCT_CATEGORY_REQUEST,
  ADD_PRODUCT_CATEGORY_SUCCESS,
  ADD_PRODUCT_CATEGORY_FAIL,
  GET_PRODUCT_CATEGORIES_REQUEST,
  GET_PRODUCT_CATEGORIES_SUCCESS,
  GET_PRODUCT_CATEGORIES_FAIL,
  CLEAR_PRODUCT_ERRORS,
  CLEAR_PRODUCT_MESSAGES,
} from "../constants/productConstants";

const initialCategoryState = {
  categories: [],
  categoryLoading: false,
  categoryError: null,
  categoryMessage: null,
};

export const productCategoryReducer = (state = initialCategoryState, action) => {
  switch (action.type) {
    case ADD_PRODUCT_CATEGORY_REQUEST:
    case GET_PRODUCT_CATEGORIES_REQUEST:
      return { ...state, categoryLoading: true, categoryError: null };

    case ADD_PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state,
        categoryLoading: false,
        categories: [...state.categories, action.payload],
        categoryMessage: "Category added successfully.",
      };
    case GET_PRODUCT_CATEGORIES_SUCCESS:
      return {
        ...state,
        categoryLoading: false,
        categories: Array.isArray(action.payload?.categories)
          ? action.payload.categories
          : [],
        categoryMessage: action.payload?.message || "",
      };
    case ADD_PRODUCT_CATEGORY_FAIL:
    case GET_PRODUCT_CATEGORIES_FAIL:
      return { ...state, categoryLoading: false, categoryError: action.payload };

    case CLEAR_PRODUCT_ERRORS:
      return { ...state, categoryError: null };
    case CLEAR_PRODUCT_MESSAGES:
      return { ...state, categoryMessage: null };

    default:
      return state;
  }
};
